import Modal from '@components/common/modal';
import classnames from 'classnames/bind';
import styles from './modal.module.scss';
const cx = classnames.bind(styles);

export type ModalState = 'PROFILE_SAMPLE' | null;

interface EventProfileFillProps {
  modalState: ModalState;
  setModalState: (modalState: ModalState) => void;
}

const EventProfileFill = ({ modalState, setModalState }: EventProfileFillProps) => {
  const isVisible = (state: ModalState) => state === modalState;
  const closeModal = () => setModalState(null);

  return (
    <>
      <SampleModal modalState={modalState} visible={isVisible('PROFILE_SAMPLE')} onClose={closeModal} />
    </>
  );
};

export default EventProfileFill;

interface SampleModalProps {
  modalState: ModalState;
  visible: boolean;
  onClose: () => void;
}
const SampleModal = ({ modalState, visible, onClose }: SampleModalProps) => {
  return (
    <Modal visible={visible} onClickBg={onClose}>
      <div className={cx('wrapper')}>
        <div className={cx('scrollArea')}>
          <div className={cx('scrollInner')}>
            <div className={cx('sampleImg', modalState)} />
          </div>
        </div>
      </div>
    </Modal>
  );
};
